var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desktop-class-selector"},[_c('ClassSelector',{attrs:{"device-type":"pc"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }